import { useState } from 'react';
import { SignedIn, SignedOut, SignInButton } from '@clerk/clerk-react';
import { useApi } from '../../lib/api';

export default function SellerApply() {
  const api = useApi();
  const [form, setForm] = useState({
    full_name: '',
    phone: '',
    mailing_address: '',
    giants_account_id: '',
    season: '2026',
    agree_tos: false,
  });
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    try {
      await api('/sellers/apply', { method: 'POST', body: JSON.stringify(form) });
      setDone(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'error');
    }
  }

  return (
    <section>
      <h2>Seller application</h2>
      <SignedOut>
        <p className="muted">Sign in or create an account to apply.</p>
        <SignInButton mode="modal" />
      </SignedOut>
      <SignedIn>
        {done ? (
          <div className="card">
            <h3>Application submitted</h3>
            <p>We'll review within 48 hours. You'll receive an email when a decision is made.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="card" style={{ maxWidth: 560 }}>
            <label>
              <span>Full legal name</span>
              <input
                required
                value={form.full_name}
                onChange={(e) => setForm({ ...form, full_name: e.target.value })}
              />
            </label>
            <label>
              <span>Phone</span>
              <input
                required
                value={form.phone}
                onChange={(e) => setForm({ ...form, phone: e.target.value })}
              />
            </label>
            <label>
              <span>Mailing address</span>
              <textarea
                required
                rows={3}
                value={form.mailing_address}
                onChange={(e) => setForm({ ...form, mailing_address: e.target.value })}
              />
            </label>
            <label>
              <span>Giants Account Manager ID</span>
              <input
                required
                value={form.giants_account_id}
                onChange={(e) => setForm({ ...form, giants_account_id: e.target.value })}
              />
            </label>
            <label>
              <span>Season</span>
              <input
                required
                value={form.season}
                onChange={(e) => setForm({ ...form, season: e.target.value })}
              />
            </label>
            <label style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
              <input
                type="checkbox"
                checked={form.agree_tos}
                onChange={(e) => setForm({ ...form, agree_tos: e.target.checked })}
                style={{ width: 'auto' }}
              />
              <span style={{ margin: 0 }}>
                I agree to the{' '}
                <a href="/legal/terms" target="_blank" rel="noreferrer">
                  Seller Terms of Service
                </a>
                .
              </span>
            </label>
            <button disabled={!form.agree_tos}>Submit application</button>
            {error && <p style={{ color: 'crimson' }}>{error}</p>}
          </form>
        )}
      </SignedIn>
    </section>
  );
}
